export const kohLarnGetYourGuideAttractions = {
  'bangkok-pattaya-vip-day-trip-to-koh-larn':
    'https://www.getyourguide.com/pattaya-l182/bangkokpattayavip-day-trip-to-koh-larn-with-water-sports-t1075445/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  'pattaya-koh-larn-trip':
    'https://www.getyourguide.com/pattaya-l182/pattayakoh-larn-trip-with-snorkeling-jetski-and-parasailing-t1003026/?partner_id=Q3VFO4H&utm_medium=online_publisher',
};
